/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_Profile_LoadedInputs */

const en_hero_profile_loaded = /** @type {(inputs: Hero_Profile_LoadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profile loaded: Sohan Emon`)
};

const ar_hero_profile_loaded = /** @type {(inputs: Hero_Profile_LoadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم تحميل الملف الشخصي: سوهان إيمون`)
};

const bn_hero_profile_loaded = /** @type {(inputs: Hero_Profile_LoadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রোফাইল লোড হয়েছে: সোহান ইমন`)
};

const de_hero_profile_loaded = /** @type {(inputs: Hero_Profile_LoadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil geladen: Sohan Emon`)
};

const es_hero_profile_loaded = /** @type {(inputs: Hero_Profile_LoadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil cargado: Sohan Emon`)
};

const fr_hero_profile_loaded = /** @type {(inputs: Hero_Profile_LoadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil chargé : Sohan Emon`)
};

const pt_hero_profile_loaded = /** @type {(inputs: Hero_Profile_LoadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil carregado: Sohan Emon`)
};

const zh_hero_profile_loaded = /** @type {(inputs: Hero_Profile_LoadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`个人资料已加载：Sohan Emon`)
};

const tr_hero_profile_loaded = /** @type {(inputs: Hero_Profile_LoadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil yüklendi: Sohan Emon`)
};

const ru_hero_profile_loaded = /** @type {(inputs: Hero_Profile_LoadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Профиль загружен: Сохан Эмон`)
};

const pl_hero_profile_loaded = /** @type {(inputs: Hero_Profile_LoadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Załadowano profil: Sohan Emon`)
};

/**
* | output |
* | --- |
* | "Profile loaded: Sohan Emon" |
*
* @param {Hero_Profile_LoadedInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const hero_profile_loaded = /** @type {((inputs?: Hero_Profile_LoadedInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_Profile_LoadedInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_hero_profile_loaded(inputs)
	if (locale === "bn") return bn_hero_profile_loaded(inputs)
	if (locale === "de") return de_hero_profile_loaded(inputs)
	if (locale === "es") return es_hero_profile_loaded(inputs)
	if (locale === "fr") return fr_hero_profile_loaded(inputs)
	if (locale === "pt") return pt_hero_profile_loaded(inputs)
	if (locale === "zh") return zh_hero_profile_loaded(inputs)
	if (locale === "tr") return tr_hero_profile_loaded(inputs)
	if (locale === "ru") return ru_hero_profile_loaded(inputs)
	if (locale === "pl") return pl_hero_profile_loaded(inputs)
	return en_hero_profile_loaded(inputs)
});